import type { WidgetHeaderConfig } from './WidgetHeaderContext.js';

/** Merges a partial header patch into the previous config (undefined fields keep previous values). */
export function mergeWidgetHeaderConfig(prev: WidgetHeaderConfig, patch: WidgetHeaderConfig): WidgetHeaderConfig {
  return {
    title: patch.title !== undefined ? patch.title : prev.title,
    menuItems: patch.menuItems !== undefined ? patch.menuItems : prev.menuItems,
    toolbarEnd: patch.toolbarEnd !== undefined ? patch.toolbarEnd : prev.toolbarEnd,
  };
}

/** Reference equality on title, menuItems, and toolbarEnd (used to skip redundant header updates). */
export function widgetHeaderConfigsEqual(a: WidgetHeaderConfig, b: WidgetHeaderConfig): boolean {
  return a.title === b.title && a.menuItems === b.menuItems && a.toolbarEnd === b.toolbarEnd;
}
